module.exports = __webpack_public_path__ + "static/media/next.65380ea5.svg";